// extracted by mini-css-extract-plugin
export var chevron = "bb_cG";
export var chevronLeft = "bb_cH";
export var chevronRight = "bb_cJ";
export var link = "bb_b5";
export var variant1 = "bb_bD";
export var variant2 = "bb_bF";